import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { variantId: String, year: String }

  addToCart(event) {
    this.dispatch("addToCart", { detail: { content: { productId: this.variantIdValue, year: this.yearValue } } })
  };
}
